export default __webpack_public_path__ + "images/nvent-raychem-sidebyside-logo@3x.png?0e5ea20760297aaa8009ad5e9c34d6e7";